import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'prlw-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavbarComponent {}
